export default "__VITE_ASSET__zxZqf8Kw__"